/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable @typescript-eslint/prefer-namespace-keyword */
/**
 * Generate models with NSwagStudio: https://github.com/RSuter/NSwag/wiki/NSwagStudio
 * Make sure to point at the docs url in the top green header
 * IE http://localhost:57462/swagger/docs/v1
 * NOT http://localhost:57462/swagger/ui/index#/

 Config Options:
  - Set namespace to Models
  - TS version 2.7
  - Generate DTO types: Checked
  - Type Style: Interface
  - Null Value: Null
  - Leave everything else blank or unchecked here
 */

import { ColumnMenuTab } from '@ag-grid-community/core';
import { SyncType } from '../../models';
import { SubjectPropertyType } from '../../cmg-1003/models';
import { ToastMessageOptions } from 'primeng/api';

export module Models {
  /** A custom hybrid of our API's Models.ColumnData and AG Grid's ColDef model. */
  export interface HybridColDef {
    colId?: string;
    comparator?: (valueA: string, valueB: string) => number;
    dataType?: LayoutColumnType;
    field?: string;
    filter?: string;
    filterParams?: FilterParams;
    headerName?: string;
    menuTabs?: ColumnMenuTab[];
    enableRowGroup?: boolean;
    rowGroupIndex?: number;
    width?: number;
    pinned?: boolean | 'left' | 'right' | null;
    cellClass?: string | string[];
    headerClass?: string | string[];
  }

  export interface FilterParams {
    comparator?: (filterValue: Date, cellValue: string) => 0 | 1 | -1;
    defaultToNothingSelected?: boolean;
    values?: string[];
    inRangeInclusive?: boolean;
    buttons?: string[];
    allowedCharPattern?: string;
    filterOptions?: string[];
    numberParser?: (text: string | null) => number | null;
    numberFormatter?: (value: number | null) => string | null;
    valueFormatter?: (value: string | null) => string | null;
  }

  export interface LoanStatusLookup {
    id?: string;
    name?: string;
    value?: string;
  }

  export interface RetailLeadTypesLookup {
    id?: string;
    name?: string;
  }

  export interface RetailLoCompPlanTypesLookup {
    id?: string;
    name?: string;
  }

  export enum QuickActionType {
    // Loans
    LoanDetails = 'Loan Details',
    EmailBorrowers = 'Email Borrowers',
    GoToDocs = 'Go to Docs',
    Scratchpad = 'Scratchpad',
    LoanNotes = 'Loan Notes',
    UploadDocs = 'Upload Docs',
    AUS = 'AUS',
    Disclosures = 'Disclosures',
    Parties = 'Parties',
    AddConcurrentLoans = 'Add Concurrent Loan(s)',
    RemoveConcurrentLoans = 'Remove Concurrent Loan(s)',
    GenerateDownloadDocuments = 'Generate and Download Documents',

    DataEnrichment = 'Data Enrichment',
    // Leads
    EditLead = 'Edit Lead',

    // Applications
    ViewApplication = 'View Application',

    // Leads, Applications
    EmailBorrower = 'Email Borrower',
    ConvertToLoan = 'Convert to Loan',

    // Closed Loans
    OpportunityAnalysis = 'Opportunity Analysis',
    // Condo Processing
    CondoProcessing = 'Condo Processing',

    // https://dev.azure.com/cmgfidev/Next%20Gen%20LOS/_workitems/edit/45409
    OfferTransactionHistory = 'Offer Transaction History',

    // Partners
    CopyCoBrandedLink = 'Copy Co-Branded Link',
    SendInviteToPortal = 'Send Invite to Portal',
    InvitePartners = 'Invite Partners',
    EditPartner = 'Edit Partner',
    DeactivateCoBranding = 'Deactivate Co-Branding',
    ActivateCoBranding = 'Activate Co-Branding',
  }

  /**
   * Byte values: https://cmgfi.atlassian.net/browse/URLA2-1482
   *
   * As of 3/28/2023, only Blank, DisclosureFlag, and QCSelectedFlag are used.
   */
  export enum FollowUpFlag {
    Blank = 0,
    DisclosureFlag = 1,
    BlueFlag = 2,
    YellowFlag = 3,
    GreenFlag = 4,
    QCSelectedFlag = 5,
    PurpleFlag = 6,
  }

  export enum LoanFlags {
    UserHasAValidStateLicense = 1,
    UserDoesNotHaveAValidStateLicense = 2,
    AnyBorrowerMissingSsn = 3,
    LOMustHaveORorWALicense = 4,
  }

  /********************************
   *  BEGIN NSWAG COPY/PASTE
   ********************************/
  //----------------------
  // <auto-generated>
  //     Generated using the NSwag toolchain v13.1.6.0 (NJsonSchema v10.0.28.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
  // </auto-generated>
  //----------------------
  export interface ColumnData {
    aggFunc?: string;
    colId?: string;
    field?:
      | keyof Models.PipelineLoanFile
      | keyof Models.Lead
      | keyof Models.PipelineServicingLoan
      | keyof Models.PipelinePartner
      | 'tagsLabels'
      | 'actions';
    headerName?: string;
    hide?: boolean;
    label?: string;
    pinned?: boolean | 'left' | 'right' | null;
    pivotIndex?: number;
    rowGroupIndex?: number;
    type?: LayoutColumnType;
    width?: number;
    cellRenderer?: unknown;
  }

  export interface EntityCreationResponse {
    guid?: string;
  }

  export interface FilterData {
    filterType?: string;
    values?: string[];
  }

  export interface Layout {
    guid?: string;
    pipelineType?: PipelineType;
    displayName?: string;
    layoutConfig?: LayoutConfig;
    visibility?: LayoutVisibility;
    teamGUID?: string;
    userGUID?: string;
    isDefault?: boolean;
  }

  export interface LayoutColumn {
    guid?: string;
    pipelineType?: PipelineType;
    label?: string;
    field?: string;
    type?: LayoutColumnType;
  }

  export enum LayoutColumnType {
    Text = 'Text',
    Date = 'Date',
    Phone = 'Phone',
    Email = 'Email',
    Percent = 'Percent',
    Checkbox = 'Checkbox',
    Currency = 'Currency',
    Enhanced = 'Enhanced',
    Number = 'Number',
    Multi = 'Multi',
  }

  export interface LayoutConfig {
    columns?: ColumnData[];
    filters?: { [key: string]: FilterData };
    sorts?: SortData[];
    searchFilter?: string;
  }

  export enum LayoutVisibility {
    Global = 'Global',
    Team = 'Team',
    User = 'User',
  }

  export enum FileUsedType {
    Unknown = 0,
    _32 = 1, // 1003
    _34 = 2, // URLA
  }

  export interface LeadTag {
    guid?: string;
    leadGUID?: string;
    tagGUID?: string;
  }

  export interface LoanApplicationTag {
    guid?: string;
    loanApplicationGUID?: string;
    tagGUID?: string;
  }

  export interface LoanTag {
    guid?: string;
    byteFileDataID?: number;
    tagGUID?: string;
  }

  export interface PipelineDocCounts {
    numWaiting?: number;
    numNeedsReview?: number;
    numReviewed?: number;
    errorFetchingCounts?: boolean;
  }

  export interface PipelineLoanApplication {
    // ==== Start: For UI only. ==== //
    loanApplicationBorrowerName?: string;
    loanApplicationBorrowerEmail?: string;
    source?: string;
    realtor?: string;
    isSubmitted?: boolean | string; // Added string for UI.
    // ==== End: For UI only. ==== //

    guid?: string;
    loanApplicationNumber?: string;
    byteFileDataID?: number;
    byteFileName?: string;
    financialsVerificationProvider?: FinancialsVerificationProvider;
    loanAmount?: number;
    loanPurposeType?: LoanPurposeType;
    loanPurposeExplanation?: string;
    purchaseStage?: PurchaseStage;
    refinanceGoal?: RefinanceGoal;
    dateStarted?: Date;
    dateSubmitted?: Date;
    isWorkingWithRealtor?: boolean;
    realtorFirstName?: string;
    realtorLastName?: string;
    realtorMobileNumber?: string;
    realtorEmailAddress?: string;
    borrowerFirstName?: string;
    borrowerLastName?: string;
    borrowerCellPhoneNumber?: string;
    borrowerEmailAddress?: string;
    howDidYouHearAboutUs?: ReferrerSource;
    referrerName?: string;
    propertyAddressLine1?: string;
    propertyAddressLine2?: string;
    propertyUnit?: string;
    propertyCity?: string;
    propertyState?: string;
    propertyZipCode?: string;
    propertyCountry?: string;
  }

  interface Note {
    guid: string;
    content: string;
    dateInserted: string;
    insertedBy: string;
    dateUpdated: string;
    updatedBy: string;
  }

  export type LoanApplicationNote = Note & {
    loanApplicationGUID: string;
  };

  export type LeadNote = Note & {
    leadGUID: string;
  };

  export interface PipelineLoanFile {
    // ==== Start: For UI only. ==== //
    borrowerName?: string;
    coBorrowerName?: string;
    cdSignedDate?: Date;
    ausLastRunDate?: Date;
    appraisalWaiver?: boolean | string; // Added string for UI.
    pricing?: any;
    syncedLoanTooltip?: string;
    syncedLoansLinked?: number[];
    // ==== End: For UI only. ==== //

    fileDataId?: number;
    fileName?: string;
    fileUsed?: FileUsedType;
    dateCreated?: Date;
    dateModified?: Date;
    borrowerFirstName?: string;
    borrowerLastName?: string;
    borrowerMobilePhone?: string;
    borrowerHomePhone?: string;
    borrowerGeneration?: string;
    borrowerEmail?: string;
    cB_FN?: string;
    cB_LN?: string;
    cB_G?: string;
    cB_E?: string;
    cB_MP?: string;
    listingAgent?: string;
    listingAgentPhone?: string;
    listingAgentCompany?: string;
    loanProgramName?: string;
    loanPurpose?: string;
    loanStatus?: string;
    loanStatusDescription?: string;
    mortgageType?: string;
    processingHoldReason?: string;
    processor?: string;
    productionAssistant?: string;
    propertyAddress?: string;
    sellingAgent?: string;
    sellingAgentPhone?: string;
    sellingAgentCompany?: string;
    state?: string;
    titleCompany?: string;
    totalLoanAmount?: number;
    underwriter?: string;
    applicationDate?: Date;
    appraisalOrderedDate?: Date;
    appraisalReceivedDate?: Date;
    cdRequestedDate?: Date;
    commitmentDate?: Date;
    creditFirstIssuedDate?: Date;
    intentToProceedDate?: Date;
    leRequestedDate?: Date;
    lockExpirationDate?: Date;
    processingHoldDate?: Date;
    schedClosingDate?: Date;
    intRate?: number;
    lastDURunDate?: Date;
    lastDUResult?: number;
    lastLPARunDate?: Date;
    lastLPAResult?: number;
    lastDUEarlyAssessmentRunDate?: Date;
    lastDUEarlyAssessmentResult?: number;
    tags?: string[];
    docCounts?: PipelineDocCounts;
    processingAssistant?: string;
    loanOfficer?: string;
    statusChangedDate?: Date;
    medianCreditScores?: (number | undefined)[];
    alert?: number;
    loanFlags?: number[]; // Uses enum: LoanFlags
    pricedProductName?: string;
    timePriced?: Date;
    syncType?: SyncType;
    syncedLoans?: PipelineLoanFile[];
    sellerName?: string;
    sellerPhone?: string;
    lockStartDate?: Date;
    organizationCode?: string;
    propertyState?: string;
    propertyCounty?: string;
    loanProgramCode?: string;
    originationChannel?: OriginationChannel | string;
    organizationName?: string;
    fundingDate?: Date;
    noiDueDate?: Date;
    cdBy?: Date;
    revisedLEReviewNeeded?: Date;
    docsSentDate?: Date;
    fileReceived?: Date;
    cdDeliveryDate?: Date;
    cdSentDate?: Date;
    cocRequestedOnCD?: Date;
    cocStartDate?: Date;
    cdSentToTitleDate?: Date;
    cdSentToBorrowerDate?: Date;
    coCStartDate?: Date;
    coCRequestedOnCD?: Date;
    docsBackDate?: Date;
    fastPassRequested?: Date;
    uwReceived?: Date;
    preApprovedDate?: Date;
    creditOnlyDate?: Date;
    ctcRequested?: Date;
    acceptedClosedDate?: Date;
    processingHoldRelease?: Date;
    clearToCloseDate?: Date;
    hybridECloseRequested?: Date;
    schedFundingDate?: Date;
    disbursementDate?: Date;
    cdRequested?: Date;
    funderName?: string;
    hasProcessorExtendedFields?: boolean | string;
    disclosureCoordinator?: string;
    occupancyType?: string;
    closerNotes?: string;
    cdDisclosureTestResult?: string;
    disclosureCoorNotes?: string;
    deferredForInitialDisclosure?: string;
    propertyType?: SubjectPropertyType;
    conditionsForReviewReason?: string;
    jrloName?: string;
    fundingType?: string;
    closer?: string;
    loanOfficerName?: string;
    signingAppointmentTime?: string;
    reconcileRequest?: boolean | string;
    isHFILoan?: boolean | string;
    isHFMLoan?: boolean | string;
    initialDisclosureRushRequested?: boolean | string;
    withdrawnRequested?: boolean | string;
    isHOV?: boolean | string;
    rushInitialUWDecisionReq?: boolean | string;
    rushConditionReview?: boolean | string;
    rushCTC?: boolean | string;
    isISGNProcessingAssigned?: boolean | string;
    isWhiteGlove?: boolean | string;
    rushFundingAppr?: boolean | string;
    wireInstructionsConfirmed?: boolean | string;
    rushCDApproval?: boolean | string;
    isMailAway?: boolean | string;
    isCMG2Loan?: boolean | string;
    hasBuydowns?: boolean | string;
    propertyTBD?: boolean | string;
    originatedInClear?: boolean | string;
    used34File?: boolean | string;
    hasSixAppDataPoints?: boolean | string;
    loanAmount?: number;
    prequalDate?: Date;
    commitmentDateMet?: Date;
    conditionsDiscussedWithBorrowerDate?: Date;
    leDueDate?: Date;
    nyCollatReqCustodianDate?: Date;
    // Sandbox Loan identifier
    sandboxFileDataId?: number;
    isCrossBusinessEntity?: boolean;
    /** Whether this loan has unread notes for the current user */
    hasUnread?: boolean;
  }

  export enum PipelineType {
    Lead = 'Lead',
    LoanApplication = 'LoanApplication',
    /** @deprecated Backend-only value. The Active Loans pipeline UI was removed (ADO #86531) but the backend API still returns this value for tags and loan records. Do not use for new UI features. */
    Loan = 'Loan',
    ServicingLoan = 'ServicingLoan',
    AllLoans = 'AllLoans',
    Ops = 'Ops',
    Partners = 'Partners',
    LoanNote = 'LoanNote',
  }

  export enum PortfolioOriginFilter {
    OnlyPortfolio = 'OnlyPortfolio',
    OnlyNonPortfolio = 'OnlyNonPortfolio',
    AllLoans = 'AllLoans',
  }

  export enum MarketingOriginFilter {
    OnlyMarketable = 'OnlyMarketable',
    OnlyNonMarketable = 'OnlyNonMarketable',
    AllLoans = 'AllLoans',
  }

  export enum OpportunityPipelineLoanFilter {
    // 'Portfolio (marketable)',
    Portfolio = 'Portfolio',
    // 'Funded & Sold (view only)',
    FundedSold = 'FundedSold',
    // 'Ingested (marketable)',
    Ingested = 'Ingested',
  }

  export interface SecurityProfile {
    organizationId?: number;
    organizationCode?: string;
    organizationName?: string;
    securityProfileId?: number;
    securityProfileName?: string;
    userOrgProfileId?: number;
  }

  export interface LoanOfficer {
    organizationId: number;
    organizationCode: string;
    organizationName: string;
    userId: number;
    username: string;
    fullname?: string;
    nmlsid?: string;
  }

  export interface LoanOfficerLicense {
    expirationDate: string;
    licenseNumber: string;
    state: string;
  }

  export interface SecurityProfiles {
    profiles?: SecurityProfile[];
  }

  export interface SortData {
    colId?: string;
    sort?: SortType;
  }

  export enum SortType {
    Desc = 'Desc',
    Asc = 'Asc',
  }

  export interface Tag {
    guid?: string;
    pipelineType?: PipelineType;
    name?: string;
    backgroundColor?: string;
    textColor?: string;
    isGlobal?: boolean;
    isSystem?: boolean;
    userGUID?: string;
    hoverBackgroundColor?: string;
    hoverTextColor?: string;
  }

  export interface User {
    guid?: string;
    username?: string;
    firstName?: string;
    lastName?: string;
    layoutGUID?: string;
  }

  export enum OriginationChannel {
    Retail = 'Retail',
    BrokeredOut = 'BrokeredOut',
  }

  export enum RetailLoCompPlan {
    AioRct = 'AioRct',
    InStateLoanReferral = 'InStateLoanReferral',
    InitialCompPeriod = 'InitialCompPeriod',
    SrJrComp = 'SrJrComp',
    StandardComp = 'Standard Comp',
    TeamComp = 'TeamComp',
    TeamLeadComp = 'TeamLeadComp',
  }

  export enum RetailLeadType {
    Select = '',
    Aio = 'Aio',
    BranchGenerated = 'Branch Generated',
    BranchGeneratedAio = 'Branch Generated AIO',
    BrokeredOut = 'Brokered Out',
    BuilderBrokered = 'Builder Brokered',
    BuilderInHouse = 'BuilderInHouse',
    BusinessDevelopment = 'BusinessDevelopment',
    CompanyGenerated = 'Company Generated',
    CompanyGeneratedAio = 'Company Generated AIO',
    EmpToEmpLoanReferral = 'EmpToEmpLoanReferral',
    Heloc = 'Heloc',
    InternalEmployeeLoan = 'InternalEmployeeLoan',
    NewConstruction = 'NewConstruction',
    PortfolioRefinance = 'Portfolio Refinance',
    RefiNowOrRefiPlus = 'RefiNowOrRefiPlus',
    ReverseMortgageBrokered = 'ReverseMortgageBrokered',
    Rog = 'Rog',
    SelfGenerated = 'Self Generated',
    Relo = 'RELO',
    ReloAio = 'RELO AIO',
    PortfolioRefinanceStandard = 'Portfolio Refinance - Standard',
    PortfolioRefinanceAIO = 'Portfolio Refinance - AIO',
    PortfolioRefinanceReclaim = 'Portfolio Refinance - Reclaim',
  }

  export enum MaritalStatus {
    Single = 'Single',
    Married = 'Married',
    Divorced = 'Divorced',
  }

  export enum EmploymentStatus {
    Employed = 'Employed',
    Unemployed = 'Unemployed',
    Retired = 'Retired',
  }

  export enum ContactTimeOfDay {
    Morning = 'Morning',
    Afternoon = 'Afternoon',
    Evening = 'Evening',
  }

  export enum ContactTimeZone {
    PST = 'PST',
    MST = 'MST',
    CST = 'CST',
    EST = 'EST',
    HST = 'HST',
  }

  export enum LoanPurposeType {
    Purchase = 'Purchase',
    Refinance = 'Refinance',
    Other = 'Other',
  }

  export enum PropertyType {
    SingleFamily = 'SingleFamily',
    MultiFamily = 'MultiFamily',
    Land = 'Land',
    Condominium = 'Condominium',
  }

  export enum AmortizationType {
    StraightLine = 'StraightLine',
    DecliningBalance = 'DecliningBalance',
    Annuity = 'Annuity',
    Bullet = 'Bullet',
    NegativeAmortization = 'NegativeAmortization',
  }

  export interface ReferralTypeOption {
    referralID: number;
    referralType: string;
    referralCompany: string;
    referralContactName: string;
    referralContactNumber: string;
    referralEmailAddress: string;
    referralAddress: string;
    referralCity: string;
    referralState: string;
    referralZipCode: string;
    referralPartner: string;
  }

  export enum ReferralType {
    Builder = 'Builder',
    MSA = 'MSA',
    DeskRental = 'DeskRental',
    Realtor = 'Realtor',
    PastCustomer = 'Past Customer',
    FinancialPlanner = 'Financial Planner',
    LeadShare = 'Leadshare',
    Other = 'Other',
    NotApplicable = 'NotApplicable',
  }

  export interface Lead {
    // ==== Start: For UI only. ==== //
    leadBorrowerName?: string;
    leadEmailAddress?: string;
    converted?: string;
    // ==== End: For UI only. ==== //
    guid?: string;
    leadNumber?: string;
    assignedLoanOfficerByteUserID?: number;
    assignedLoanOfficerByteUserOrgProfileID?: number;
    assignedLoanOfficerByteOrganizationID?: number;
    assignedLoanOfficerFullName?: string;
    byteFileDataID?: number;
    byteFileName?: string;
    originationChannel?: OriginationChannel | string;
    retailLoCompPlan?: RetailLoCompPlan | string;
    retailLeadType?: RetailLeadType;
    leadTypeReason?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    mobilePhone?: string;
    homePhone?: string;
    workPhone?: string;
    emailAddress?: string;
    maritalStatus?: MaritalStatus;
    employmentStatus?: EmploymentStatus;
    creditScore?: number;
    creditProfile?: string;
    isCallCompleted?: boolean | string;
    preferredContactDate?: Date | string;
    preferredContactTimeOfDay?: ContactTimeOfDay;
    preferredContactTimeZone?: ContactTimeZone;
    addressLine1?: string;
    addressLine2?: string;
    unit?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    county?: string;
    loanPurposeType?: LoanPurposeType;
    isPurchasingWithin90Days?: boolean | string;
    purchasePrice?: number;
    downPayment?: number;
    downPaymentPercent?: number;
    estimatedPropertyValue?: number;
    currentLoanBalance?: number;
    cashOutAmount?: number;
    propertyAddressLine1?: string;
    propertyAddressLine2?: string;
    propertyUnit?: string;
    propertyCity?: string;
    propertyState?: string;
    propertyZipCode?: string;
    propertyCounty?: string;
    intendedPropertyUse?: string;
    propertyType?: SubjectPropertyType;
    amortizationType?: AmortizationType;
    referralType?: ReferralType;
    referralCompany?: string;
    referralPartnerID?: number;
    referralPartner?: string;
    referralContactFullName?: string;
    referralContactPhone?: string;
    referralContactEmailAddress?: string;
    referralContactAddressLine1?: string;
    referralContactAddressLine2?: string;
    referralContactUnit?: string;
    referralContactCity?: string;
    referralContactState?: string;
    referralContactZipCode?: string;
    referralContactCounty?: string;
    dateCreated?: Date;
    tags?: string[];
  }
  export interface BorrowerInformationLeadForm {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    mobilePhone?: string;
    homePhone?: string;
    emailAddress?: string;
    creditScore?: number;
    valid?: boolean;
    dirty?: boolean;
  }
  export interface LoanOfficerInformationLeadForm {
    originationChannel?: OriginationChannel;
    assignedLoanOfficerByteUserID?: number;
    assignedLoanOfficerUserOrgProfileID?: number;
    assignedLoanOfficerByteOrganizationID?: number;
    retailLoCompPlan?: RetailLoCompPlan;
    retailLeadType?: RetailLeadType;
    leadTypeReason?: string;
    valid?: boolean;
    dirty?: boolean;
  }
  export interface LoanOfficerNotesLeadForm {
    leadNotes?: string;
    valid?: boolean;
    dirty?: boolean;
  }
  export interface PreferredTimeContactLeadForm {
    isCallCompleted?: boolean;
    preferredContactDate?: string;
    preferredContactTimeOfDay?: ContactTimeOfDay;
    preferredContactTimeZone?: ContactTimeZone;
    valid?: boolean;
    dirty?: boolean;
  }
  export interface SubjectPropertyInformationLeadForm {
    loanPurposeType?: LoanPurposeType;
    estimatedPropertyValue?: number;
    currentLoanBalance?: number;
    cashOutAmount?: number;
    purchasePrice?: number;
    downPayment?: number;
    downPaymentPercent?: number;
    isPurchasingWithin90Days?: boolean;
    propertyAddressLine1?: string;
    propertyUnit?: string;
    propertyZipCode?: string;
    propertyCity?: string;
    propertyState?: string;
    propertyCounty?: string;
    valid?: boolean;
    dirty?: boolean;
  }
  export interface SourceInformationLeadForm {
    referralType: ReferralType;
    referralPartnerID: number;
    referralPartner: string;
    referralCompany: string;
    referralContactFullName: string;
    referralContactPhone: string;
    referralContactEmailAddress: string;
    referralContactAddressLine1: string;
    referralContactZipCode: string;
    referralContactCity: string;
    referralContactState: string;
    valid?: boolean;
    dirty?: boolean;
  }

  export interface LoanReferral {
    referralType: string;
    referralCompany: string;
    referralContactName: string;
    referralContactNumber: string;
    referralEmailAddress: string;
    referralAddress: string;
    referralCity: string;
    referralState: string;
    referralZipCode: string;
    referralPartner: string;
    id?: string; // Generated on UI
  }

  /********************************
   *  END NSWAG COPY/PASTE
   ********************************/
  export interface LeadForm extends Lead {
    isLoanOfficer?: boolean;
  }

  export interface LoanApplication {
    guid?: string;
    wizardConfigurationGUID?: string;
    userGUID?: string;
    assignedLoanOfficerDomoID?: string;
    assignedLoanOfficerByteUserID?: number;
    assignedLoanOfficerByteUsername?: string;
    byteFileDataID?: number;
    byteFileName?: string;
    cmgDocsLoanGUID?: string;
    isSubmitted?: boolean;
    isWaitingOnVerificationReports?: boolean;
    financialsVerificationProvider?: FinancialsVerificationProvider;
    applicationStateJsonString?: string;
    loanAmount?: number;
    loanApplicationNumber?: string;
    loanPurposeType?: LoanPurposeType;
    loanPurposeExplanation?: string;
    purchaseStage?: PurchaseStage;
    refinanceGoal?: RefinanceGoal;
    propertyGUID?: string;
    dateStarted?: Date;
    dateSubmitted?: Date;
    dateUpdated?: Date;
    marketingTrackingCode?: string;
    monthlyMortgagePayment?: number;
    abandonedEmailSent?: boolean;
    isWorkingWithRealtor?: boolean;
    realtorFirstName?: string;
    realtorLastName?: string;
    realtorMobileNumber?: string;
    realtorEmailAddress?: string;
    isAdditionalInfoIncluded?: boolean;
    property?: Property;
    borrowers?: Borrower[];
    tags?: string[];
    currentAddress?: BorrowerCurrentAddress;
    ltv?: number;
    cltv?: number;
    cashToClose?: number;
    referral?: Referral;
    loanOfficerName?: string;
    loanOfficerNmlsId?: string;
    partnerGuids?: string[] | undefined;
  }

  export interface Referral {
    loanOfficerName?: string;
  }

  export interface BorrowerCurrentAddress {
    guid?: string;
    moveInDate?: Date;
    moveOutDate?: Date;
    housingExpenseType?: string;
    monthlyHousingExpense?: string;
    addressGUID?: string;
    dateInserted?: Date;
    insertedBy?: string;
    dateUpdated?: Date;
    updatedBy?: string;
    address?: LoanApplicationBorrowerAddress;
  }

  export interface LoanApplicationBorrowerAddress {
    guid?: string;
    addressLine1?: string;
    addressLine2?: string;
    unit?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
    loanApplicationGUID?: string;
    dateInserted?: Date;
    insertedBy?: string;
    dateUpdated?: Date;
    updatedBy?: string;
  }

  export interface LoanConvertedNotification {
    loanApplicationId?: string;
    byteFileDataId?: number;
    isConversionFailed?: boolean;
    errorMessage?: string;
  }

  export enum FinancialsVerificationProvider {
    Plaid = 'Plaid',
    AccountChek = 'AccountChek',
  }

  export enum PurchaseStage {
    SignedPurchaseContract = 'SignedPurchaseContract',
    ConsideringMakingAnOffer = 'ConsideringMakingAnOffer',
    ActivelySearching = 'ActivelySearching',
    HaventStartedSearching = 'HaventStartedSearching',
  }

  export enum RefinanceGoal {
    LowerRate = 'LowerRate',
    LowerMonthlyPayment = 'LowerMonthlyPayment',
    ShorterTerm = 'ShorterTerm',
    CashOut = 'CashOut',
  }

  export interface Property {
    guid?: string;
    addressGUID?: string;
    numberOfUnits?: number;
    propertyValue?: number;
    occupancyType?: OccupancyType;
    isFHASecondaryResidence?: boolean;
    isMixedUseProperty?: boolean;
    isManufacturedHome?: boolean;
    expectedMonthlyRentalIncome?: number;
    isPlanningToOperateBusiness?: boolean;
    address?: Address;
    propertyLoans?: PropertyLoan[];
  }

  export enum OccupancyType {
    Investment = 'Investment',
    PrimaryResidence = 'PrimaryResidence',
    SecondHome = 'SecondHome',
    Other = 'Other',
  }

  export interface Address {
    guid?: string;
    addressLine1?: string;
    addressLine2?: string;
    unit?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
  }

  export interface PropertyLoan {
    guid?: string;
    propertyGUID?: string;
    creditorName?: string;
    lienType?: LienType;
    monthlyPayment?: number;
    loanAmount?: number;
    creditLimit?: number;
  }

  export enum LienType {
    First = 'First',
    Subordinate = 'Subordinate',
  }

  export enum EstimatedCreditScore {
    IDontKnow = 'IDontKnow',
    Excellent = 'Excellent',
    Good = 'Good',
    Average = 'Average',
    Fair = 'Fair',
    Bad = 'Bad',
  }

  export enum CitizenshipStatus {
    Citizen = 'Citizen',
    PermanentResident = 'PermanentResident',
    NonPermanentResident = 'NonPermanentResident',
  }

  export enum ReferrerSource {
    Realtor = 'Realtor',
    Builder = 'Builder',
    FinancialAdvisor = 'FinancialAdvisor',
    CMGEmployee = 'CMGEmployee',
    FamilyMemberOrFriend = 'FamilyMemberOrFriend',
    CurrentOrPastLoanWithCMG = 'CurrentOrPastLoanWithCMG',
    HousingCounselingProgram = 'HousingCounselingProgram',
    CreditCounselingProgram = 'CreditCounselingProgram',
    OnlineSearch = 'OnlineSearch',
    SocialMedia = 'SocialMedia',
    OtherOnlineAd = 'OtherOnlineAd',
    MailOrPrintAd = 'MailOrPrintAd',
    RealEstateOrMortgageWebsite = 'RealEstateOrMortgageWebsite',
    Other = 'Other',
  }

  export enum BorrowerDescription {
    Owner = 'Owner',
    Renter = 'Renter',
    LivingRentFree = 'LivingRentFree',
  }

  export interface Borrower {
    guid?: string;
    loanApplicationGUID?: string;
    userGUID?: string;
    isPrimary?: boolean;
    isActive?: boolean;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    alternateNames?: string[];
    ssn?: string;
    estimatedCreditScore?: EstimatedCreditScore;
    dateOfBirth?: Date;
    citizenshipStatus?: CitizenshipStatus;
    maritalStatus?: MaritalStatus;
    numberOfDependents?: number;
    agesOfDependents?: number[];
    homePhoneNumber?: string;
    cellPhoneNumber?: string;
    workPhoneNumber?: string;
    emailAddress?: string;
    currentAddressGUID?: string;
    isCurrentAddressSameAsMailing?: boolean;
    formerAddressGUID?: string;
    formerAddress2GUID?: string;
    mailingAddressGUID?: string;
    isWorkingWithCmgLoanOfficer?: boolean;
    isFirstTimeHomeBuyer?: boolean;
    isMilitary?: boolean;
    isMilitaryActiveDuty?: boolean;
    isMilitaryRetired?: boolean;
    isMilitaryNonActivatedReserveOrNationalGuard?: boolean;
    isMilitarySurvivingSpouse?: boolean;
    militaryProjectedEndDate?: Date;
    isCreditCheckAuthorized?: boolean;
    creditAuthDate?: Date;
    creditAuthIp?: string;
    creditAuthUserAgent?: string;
    hasGivenEConsent?: boolean;
    eConsentDate?: Date;
    eConsentIp?: string;
    eConsentUserAgent?: string;
    hasNoEmploymentsToDisclose?: boolean;
    hasNoPrevEmploymentsToDisclose?: boolean;
    hasNoOtherIncomesToDisclose?: boolean;
    hasNoAssetsToDisclose?: boolean;
    hasNoGiftAssetsToDisclose?: boolean;
    hasNoOtherAssetsToDisclose?: boolean;
    hasNoLiabilitiesToDisclose?: boolean;
    hasNoRealEstateToDisclose?: boolean;
    howDidYouHearAboutUs?: ReferrerSource;
    referrerName?: string;
    whatDescribesYouBest?: BorrowerDescription;
    declarationsGUID?: string;
    demographicsGUID?: string;
    isWorkingWithInsuranceProfessional?: boolean;
    isWorkingWithFamilyPlanningSpecialist?: boolean;
    isWorkingWithFinancialPlanner?: boolean;
    isWorkingWithCertifiedPublicTaxProfessional?: boolean;
    referInsuranceProfessional?: boolean;
    referFamilyPlanningSpecialist?: boolean;
    referFinancialPlanner?: boolean;
    referCertifiedPublicTaxProfessional?: boolean;
    insuranceProfessionalGUID?: string;
    familyPlanningSpecialistGUID?: string;
    financialPlannerGUID?: string;
    certifiedPublicTaxProfessionalGUID?: string;
    hasSSN?: boolean;
    currentAddress?: PropertyAddress;
    formerAddress?: PropertyAddress;
    formerAddress2?: PropertyAddress;
    mailingAddress?: Address;
    declarations?: Declarations;
    demographics?: Demographics;
    employments?: Employment[];
    incomes?: Income[];
    assets?: Asset[];
    gifts?: Gift[];
    liabilities?: Liability[];
    realEstateOwned?: RealEstateOwned[];
    insuranceProfessional?: ProfessionalPersonnel;
    familyPlanningSpecialist?: ProfessionalPersonnel;
    financialPlanner?: ProfessionalPersonnel;
    certifiedPublicTaxProfessional?: ProfessionalPersonnel;
    hasCompletedEducation?: any;
    educationFormat?: EducationFormat;
    educationAgencyHudApproved?: boolean;
    educationAgencyID?: number;
    educationAgencyName?: string;
    educationCompletionDate?: Date;
  }

  export enum EducationFormat {
    AttendedWorkshopInPerson = 'Attended Workshop In Person',
    CompletedWebBasedWorkshop = 'Completed Web Based Workshop',
  }

  export enum ReoPropertyType {
    SingleFamily = 'SingleFamily',
    Townhome = 'Townhome',
    Condominium = 'Condominium',
    Cooperative = 'Cooperative',
    TwoToFourUnitProperty = 'TwoToFourUnitProperty',
    Multifamily = 'Multifamily',
    ManufacturedMobileHome = 'ManufacturedMobileHome',
    Commercial = 'Commercial',
    MixedUseResidential = 'MixedUseResidential',
    Farm = 'Farm',
    HomeAndBusiness = 'HomeAndBusiness',
    Land = 'Land',
    Other = 'Other',
  }

  export enum ReoStatus {
    PendingSale = 'PendingSale',
    RetainedNonRental = 'RetainedNonRental',
    RetainedRental = 'RetainedRental',
  }

  export enum ReoTitleHeldType {
    SoleOwnership = 'SoleOwnership',
    Joint = 'Joint',
  }

  export interface RealEstateOwned {
    guid?: string;
    borrowerGUID?: string;
    addressGUID?: string;
    propertyType?: ReoPropertyType;
    propertyValue?: number;
    reoStatus?: ReoStatus;
    titleHeld?: ReoTitleHeldType;
    intendedOccupancyType?: OccupancyType;
    currentOccupancyType?: OccupancyType;
    monthlyNonMortgagePayments?: number;
    monthlyRentalIncome?: number;
    hasLoans?: boolean;
    address?: Address;
    realEstateOwnedLoans?: RealEstateOwnedLoan[];
  }

  export interface RealEstateOwnedLoan {
    guid?: string;
    realEstateOwnedGUID?: string;
    creditorName?: string;
    accountNumber?: string;
    monthlyMortgagePayment?: number;
    unpaidBalance?: number;
    willBePaidOffBeforeClosing?: boolean;
    loanType?: LoanType;
    creditLimit?: number;
  }

  export enum LoanType {
    FHA = 'FHA',
    VA = 'VA',
    Conventional = 'Conventional',
    USDA = 'USDA',
    Other = 'Other',
  }

  export interface Liability {
    guid?: string;
    borrowerGUID?: string;
    liabilityType?: LiabilityType;
    otherLiabilityTypeDescription?: string;
    companyName?: string;
    accountNumber?: string;
    unpaidBalance?: number;
    monthlyPayment?: number;
    willBePaidOffBeforeClosing?: boolean;
  }

  export enum LiabilityType {
    Revolving = 'Revolving',
    Installment = 'Installment',
    Open30Day = 'Open30Day',
    Lease = 'Lease',
    Alimony = 'Alimony',
    ChildSupport = 'ChildSupport',
    SeparateMaintenance = 'SeparateMaintenance',
    JobRelatedExpenses = 'JobRelatedExpenses',
    Other = 'Other',
  }

  export enum GiftAssetType {
    CashGift = 'CashGift',
    GiftOfEquity = 'GiftOfEquity',
    Grant = 'Grant',
  }

  export enum GiftSource {
    CommunityNonprofit = 'CommunityNonprofit',
    Employer = 'Employer',
    FederalAgency = 'FederalAgency',
    LocalAgency = 'LocalAgency',
    Relative = 'Relative',
    ReligiousNonprofit = 'ReligiousNonprofit',
    StateAgency = 'StateAgency',
    UnmarriedPartner = 'UnmarriedPartner',
    Lender = 'Lender',
    Other = 'Other',
  }

  export interface Gift {
    guid?: string;
    borrowerGUID?: string;
    assetType?: GiftAssetType;
    isDeposited?: boolean;
    source?: GiftSource;
    cashOrMarketValue?: number;
  }

  export enum AssetSubType {
    FinancialInstitution = 'FinancialInstitution',
    Credit = 'Credit',
    Other = 'Other',
  }

  export enum AssetType {
    Checking = 'Checking',
    Savings = 'Savings',
    MoneyMarket = 'MoneyMarket',
    CertificateOfDeposit = 'CertificateOfDeposit',
    MutualFund = 'MutualFund',
    Stocks = 'Stocks',
    StockOptions = 'StockOptions',
    Bonds = 'Bonds',
    Retirement = 'Retirement',
    BridgeLoanProceeds = 'BridgeLoanProceeds',
    IndividualDevelopmentAccount = 'IndividualDevelopmentAccount',
    TrustAccount = 'TrustAccount',
    CashValueOfLifeInsurance = 'CashValueOfLifeInsurance',
    ProceedsFromRealEstate = 'ProceedsFromRealEstate',
    PropertyToBeSoldBeforeClosing = 'PropertyToBeSoldBeforeClosing',
    ProceedsFromNonRealEstate = 'ProceedsFromNonRealEstate',
    SecuredBorrowedFunds = 'SecuredBorrowedFunds',
    UnsecuredBorrowedFunds = 'UnsecuredBorrowedFunds',
    EarnestMoney = 'EarnestMoney',
    EmployerAssistance = 'EmployerAssistance',
    LotEquity = 'LotEquity',
    RelocationFunds = 'RelocationFunds',
    RentCredit = 'RentCredit',
    SweatEquity = 'SweatEquity',
    TradeEquity = 'TradeEquity',
    Other = 'Other',
  }

  export enum VerificationVendorType {
    Plaid = 'Plaid',
    AccountChek = 'AccountChek',
  }

  export interface Asset {
    guid?: string;
    borrowerGUID?: string;
    assetType?: AssetType;
    assetTypeExplanation?: string;
    assetSubType?: AssetSubType;
    financialInstitution?: string;
    accountNumber?: string;
    cashOrMarketValue?: number;
    vendorID?: string;
    vendorType?: VerificationVendorType;
    otherInformation?: string;
  }

  export interface ProfessionalPersonnel {
    guid?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    phoneNumber?: string;
    rating?: number;
  }

  export interface Income {
    guid?: string;
    borrowerGUID?: string;
    incomeType?: IncomeType;
    incomeTypeExplanation?: string;
    monthlyIncome?: number;
  }

  export enum IncomeType {
    Alimony = 'Alimony',
    Automobile = 'Automobile',
    BoarderIncome = 'BoarderIncome',
    CapitalGains = 'CapitalGains',
    ChildSupport = 'ChildSupport',
    Disability = 'Disability',
    FosterCare = 'FosterCare',
    HousingOrParsonage = 'HousingOrParsonage',
    InterestAndDividends = 'InterestAndDividends',
    MortgageCreditCertificate = 'MortgageCreditCertificate',
    MortgageDifferentialPayments = 'MortgageDifferentialPayments',
    NotesReceivable = 'NotesReceivable',
    PublicAssistance = 'PublicAssistance',
    Retirement = 'Retirement',
    RoyaltyPayments = 'RoyaltyPayments',
    SeparateMaintenance = 'SeparateMaintenance',
    SocialSecurity = 'SocialSecurity',
    Trust = 'Trust',
    UnemploymentBenefits = 'UnemploymentBenefits',
    VaCompensation = 'VaCompensation',
    Other = 'Other',
  }

  export interface Employment {
    guid?: string;
    borrowerGUID?: string;
    isCurrent?: boolean;
    employerOrBusinessName?: string;
    phoneNumber?: string;
    addressGUID?: string;
    positionOrTitle?: string;
    startDate?: Date;
    endDate?: Date;
    yearsInLineOfWork?: number;
    monthsInLineOfWork?: number;
    isEmployedByPartyOfTransaction?: boolean;
    isBusinessOwnerOrSelfEmployed?: boolean;
    isOwnershipGreaterThanOrEqual25Percent?: boolean;
    grossMonthlyIncomeBase?: number;
    grossMonthlyIncomeOvertime?: number;
    grossMonthlyIncomeBonus?: number;
    grossMonthlyIncomeCommission?: number;
    grossMonthlyIncomeMilitaryEntitlements?: number;
    grossMonthlyIncomeOther?: number;
    vendorID?: string;
    vendorType?: VerificationVendorType;
    employmentType?: EmploymentType;
    address?: Address;
    readonly totalMonthlyIncome?: number;
  }

  export enum EmploymentType {
    W2 = 'W2',
    ContractOrSelfEmployed = 'ContractOrSelfEmployed',
  }

  export interface Demographics {
    guid?: string;
    isHispanicOrLatino?: boolean;
    isMexican?: boolean;
    isPuertoRican?: boolean;
    isCuban?: boolean;
    isOtherHispanicOrLatino?: boolean;
    otherHispanicOrLatinoOrigin?: string;
    isNotHispanicOrLatino?: boolean;
    doNotWishToProvideEthnicity?: boolean;
    isMale?: boolean;
    isFemale?: boolean;
    doNotWishToProvideSex?: boolean;
    isAmericanIndianOrAlaskaNative?: boolean;
    americanIndianOrAlaskaNativeTribeName?: string;
    isAsian?: boolean;
    isAsianIndian?: boolean;
    isChinese?: boolean;
    isFilipino?: boolean;
    isJapanese?: boolean;
    isKorean?: boolean;
    isVietnamese?: boolean;
    isOtherAsian?: boolean;
    otherAsianRace?: string;
    isBlackOrAfricanAmerican?: boolean;
    isNativeHawaiianOrOtherPacificIslander?: boolean;
    isNativeHawaiian?: boolean;
    isGuamanianOrChamorro?: boolean;
    isSamoan?: boolean;
    isOtherPacificIslander?: boolean;
    otherPacificIslanderRace?: string;
    isWhite?: boolean;
    doNotWishToProvideRace?: boolean;
    preferredLanguage?: PreferredLanguageType;
    languageOtherDesc?: string;
  }

  export enum PreferredLanguageType {
    English = 'English',
    Spanish = 'Spanish',
    Korean = 'Korean',
    Tagalog = 'Tagalog',
    Vietnamese = 'Vietnamese',
    IDoNotWishToRespond = 'IDoNotWishToRespond',
    Other = 'Other',
  }

  export enum OtherPropertyOccupancyType {
    PrimaryResidence = 'PrimaryResidence',
    FHASecondaryResidence = 'FHASecondaryResidence',
    SecondHome = 'SecondHome',
    Investment = 'Investment',
  }

  export enum OtherPropertyOwnershipType {
    Self = 'Self',
    JointlyWithSpouse = 'JointlyWithSpouse',
    JointlyWithAnotherPerson = 'JointlyWithAnotherPerson',
  }

  export interface Declarations {
    guid?: string;
    isOccupyingPropertyAsPrimaryResidence?: boolean;
    ownedOtherPropertyInLast3Years?: boolean;
    otherPropertyOccupancyType?: OtherPropertyOccupancyType;
    otherPropertyOwnershipType?: OtherPropertyOwnershipType;
    hasAffiliationWithSeller?: boolean;
    isBorrowingMoneyNotDisclosed?: boolean;
    borrowedAmount?: number;
    isApplyingForMortgageOnAnotherProperty?: boolean;
    isApplyingForNewCredit?: boolean;
    isPropertySubjectToHigherPriorityLien?: boolean;
    isCosignerOnDebtNotDisclosed?: boolean;
    hasOutstandingJudgements?: boolean;
    isDelinguentOnFederalDebt?: boolean;
    hasPersonalFinancialLiabilityLawsuit?: boolean;
    hasConveyedTitleInLieuOfForeclosureInPast7Years?: boolean;
    hasPreForeclosureSaleInPast7Years?: boolean;
    hasForeclosureInPast7Years?: boolean;
    hasBankruptcy?: boolean;
    hasChapter7Bankruptcy?: boolean;
    hasChapter11Bankruptcy?: boolean;
    hasChapter12Bankruptcy?: boolean;
    hasChapter13Bankruptcy?: boolean;
  }

  export interface PropertyAddress {
    guid?: string;
    addressLine1?: string;
    addressLine2?: string;
    unit?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
    moveInDate?: Date;
    moveOutDate?: Date;
    housingExpenseType?: HousingExpenseType;
    monthlyHousingExpense?: number;
  }

  export enum HousingExpenseType {
    LivingRentFree = 'LivingRentFree',
    Own = 'Own',
    Rent = 'Rent',
  }

  export interface MSACounties {
    msaCountyID: number;
    name: string;
  }

  export interface Counties {
    countyID: number;
    name: string;
    countyCode: number;
    state: string;
  }

  export interface ZipCodeRow {
    zipCodeID?: number;
    zipCode?: string;
    city?: string;
    state?: string;
    county?: string;
    countyID?: number;
    latitude?: number;
    longitude?: number;
  }

  export interface LoanOfficers {
    organizationId?: number;
    organizationCode?: string;
    organizationName?: string;
    userOrgProfileId?: number;
    userId?: number;
    username?: string;
    fullname?: string;
  }

  export interface LoanLpPaList {
    loanProcessorList: LoanOfficers[];
    productionAssistantList: LoanOfficers[];
  }

  export interface LoanOfficersByOrgId extends LoanOfficers {
    licensedInStates?: string[];
  }

  export interface PipelineServicingLoan {
    servicerLoanNumber?: string;
    originationLoanNumber?: string;
    fileName?: string;
    fileDataID?: number;
    callingUserHasAccessToOriginationLoan?: boolean;
    phone1?: string;
    email1?: string;
    borrowerName?: string;
    borrowerLastName?: string;
    borrowerFirstName?: string;
    propertyState?: string;
    principalBalance?: number;
    interestRate?: number;
    loanClosingDate?: Date;
    los?: string;
    originationLoanOfficer?: string;
    originationBranchName?: string;
    originationLoanProgramName?: string;
    originationUserID?: number;
    originationUserName?: string;
    originationOrganizationID?: number;
    calculatedPaymentsLeft?: number;
    piMonthlyPayment?: number;
    miMonthlyPayment?: number;
    pimiMonthlyPayment?: number;
    propertyValue?: number;
    propertyValueDate?: Date;
    propertyValueSource?: string;
    currentLTV?: number;
    fico?: number;
    ficoDate?: Date;
    ficoSource?: string;
    revolvingDebt?: number;
    revolvingDebtMonthlyPayment?: number;
    revolvingDebtDate?: Date;
    revolvingDebtSource?: string;
    maxCashOutAmount?: number;
    debtCashOutRDNewMonthlyPIPayment?: number;
    debtCashOutRDMonthlyPIPaymentDelta?: number;
    cashOutForDebt?: number;
    debtCashOutMonthsToBreakeven?: number;
    maxCashOutNewMonthlyPIPayment?: number;
    maxCashOutMonthlyPIPaymentDelta?: number;
    maxCashOutMonthsToBreakeven?: number;
    lastOfferEmailTemplateType?: EmailTemplateType | string;
    lastOfferSentDate?: Date;
    dateOfTriggerInquiry?: Date;
    payoffRequestFlag?: boolean;
    creditTriggerFlag?: boolean;
    helocFlag?: boolean;
    reverseMortgageFlag?: boolean;
    dateOfMLSTrigger?: Date;
    mlsTriggerFlag?: boolean;
    termRefiFlag?: boolean;
    rateReductionRefiFlag?: boolean;
    miRemovalRefiFlag?: boolean;
    cashOutRefiFlag?: boolean;
    debtConsolidationFlag?: boolean;
    tags?: string[];
    newParPI15Year?: number;
    payoffRequestDate?: Date;
    isNonPortfolio?: boolean;
    isMarketable?: boolean;
    nonPortfolioLoanId?: string;
    loanId?: string;
    source?: string;
    sourceType?: string;
    lastDataEnrichmentDate?: Date;

    // For UI only.
    rdCurrPI?: number;
  }

  export interface PartnersAccessModel {
    accessReason: string;
    hasAccess: boolean;
    partnerAccessType: string;
    profileId: string;
    securityProfileId: number;
  }

  export enum PartnerAccountStatus {
    Active = 'Active',
    Deprovisioned = 'Deprovisioned',
    LockedOut = 'LockedOut',
    PasswordExpired = 'PasswordExpired',
    Provisioned = 'Provisioned',
    Recovery = 'Recovery',
    Staged = 'Staged',
    Suspended = 'Suspended',
  }

  export enum PartnerInviteStatus {
    NotInvited = 'NotInvited',
    InvitationSent = 'InvitationSent',
    AccountCreated = 'AccountCreated',
  }

  // UI friendly version of PartnerInviteStatus
  export enum PartnerInviteStatusUi {
    NotInvited = 'Not Yet Invited',
    InvitationSent = 'Invite Sent',
    AccountCreated = 'Account Created',
  }

  export interface PartnerLicense {
    guid?: string;
    licenseState?: string;
    licenseNumber?: string;
    dateExpires?: Date;
    dateInserted?: Date;
    insertedBy?: string;
    dateUpdated?: Date;
    updatedBy?: string;
  }

  export interface PipelinePartner {
    accountCreated?: Date;
    accountEmail?: string;
    accountStatus?: PartnerAccountStatus;
    company?: string;
    companyAddress?: string;
    companyCity?: string;
    companyLogoURL?: string | undefined;
    companyLogoZoom?: number;
    companyLogoPositionX?: number;
    companyLogoPositionY?: number;
    companyLogoOriginalWidth?: number;
    companyLogoOriginalHeight?: number;
    companyState?: string;
    companyZipCode?: string;
    email?: string;
    externalId?: string;
    firstName?: string;
    lastName?: string;
    guid?: string;
    headshotOriginalHeight?: number;
    headshotOriginalWidth?: number;
    headshotPositionX?: number;
    headshotPositionY?: number;
    headshotURL?: string;
    headshotZoom?: number;
    inviteStatus?: string;
    isCobrandingActive?: boolean;
    lastActivatedBy?: string;
    lastActivatedDate?: Date;
    lastDeactivatedBy?: string;
    lastDeactivatedDate?: Date;
    lastInvitedBy?: string;
    lastInvitedDate?: Date;
    lastUpdatedBy?: string;
    lastUpdatedDate?: Date;
    licenses?: PartnerLicense[];
    loanOfficerNMLS?: string;
    loanOfficerFirstName?: string;
    loanOfficerLastName?: string;
    originalCompanyLogoURL?: string;
    originalHeadshotURL?: string;
    partnerType?: string;
    phone?: string;
    phoneNumberExt?: string;
    tags?: string[];
    website?: string;
    title?: string;

    // UI only
    partner?: string;
    coBranding?: string;
    loanOfficer?: string;
  }

  export interface PartnerCobrandedLinkResponse {
    nmls?: string;
    employeeId?: string;
    email?: string;
    coBrandedLink: string;
  }

  export enum EmailTemplateType {
    ServicingLoanCashOutOffer = 'ServicingLoanCashOutOffer',
    ServicingLoanDebtConsolidationOffer = 'ServicingLoanDebtConsolidationOffer',
    ServicingLoanRateReductionRefiOffer = 'ServicingLoanRateReductionRefiOffer',
    ServicingLoanMiRemovalOffer = 'ServicingLoanMiRemovalOffer',
    ServicingLoanHelocOffer = 'ServicingLoanHelocOffer',
  }

  export interface ServicingLoanDetails {
    servicerLoanNumber?: string;
    originationLoanNumber?: string;
    fileName?: string;
    fileDataID?: number;
    callingUserHasAccessToOriginationLoan?: boolean;
    servicingData?: ServicingDataFields;
    originationData?: OriginationDataFields;
    additionalData?: AdditionalDataFields;
    pricingData?: PricingDataFields;
    pricingResults?: PricingResultsWrapper;
    tags?: string[];
    isNonPortfolio?: boolean;
    isMarketable?: boolean;
    loanId?: string;
    source?: string;

    // fields for the new endpoint moved from originationData/servicingData/pricingData
    borrowerLastName?: string;
    borrowerFirstName?: string;
    coBorrowerLastName?: string;
    coBorrowerFirstName?: string;
    email1?: string;
    email2?: string;
    interestRate?: number;
    piMonthlyPayment?: number;
    miMonthlyPayment?: number;
    proposedHODPayment?: number;
  }

  export interface AdditionalDataFields {
    principalBalance?: number;
    currentLTV?: number;
    borrowerFirstName?: string;
    borrowerLastName?: string;
    borrowerEmail?: string;
    postClosingMailingZip?: string;
    borrowerCreditScoreMedian?: number;
    borrowerAge?: number;
    coborrowerAge?: number;
    payoffRequestDate?: Date;
    payoffValidThruDate?: Date;
    dateOfTriggerInquiry?: Date;
    triggerFico?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    postalCode?: string;
    payoffRequestFlag?: boolean;
    payoffRequestScore?: number;
    creditTriggerFlag?: boolean;
    creditTriggerScore?: number;
    helocFlag?: boolean;
    helocScore?: number;
    helocMaxAmount?: number;
    helocMidAmount?: number;
    reverseMortgageFlag?: boolean;
    reverseMortgageScore?: number;
    dateOfMLSTrigger?: Date;
    mlsTriggerFlag?: boolean;
    mlsTriggerScore?: number;
  }

  export interface OriginationDataFields {
    servicerTransactionDate?: Date;
    los?: string;
    channel?: string;
    loanOfficer?: string;
    loanOfficerNMLS?: string;
    branchName?: string;
    orgName?: string;
    orgNMLS?: string;
    borrowerFirstName?: string;
    borrowerLastName?: string;
    borrowerSSN?: string;
    borrowerPhone?: string;
    borrowerEmail?: string;
    borrowerDOB?: Date;
    borrowerAge?: number;
    borrowerGender?: string;
    borrowerMaritalStatus?: string;
    borrowerIsVeteran?: boolean;
    borrowerIncome?: number;
    borrowerCreditScoreMedian?: number;
    postClosingMailingStreet?: string;
    postClosingMailingCity?: string;
    postClosingMailingState?: string;
    postClosingMailingZip?: string;
    coborrowerFirstName?: string;
    coborrowerLastName?: string;
    coborrowerSSN?: string;
    coborrowerPhone?: string;
    coborrowerEmail?: string;
    coborrowerDOB?: Date;
    coborrowerAge?: number;
    coborrowerGender?: string;
    coborrowerMaritalStatus?: string;
    coborrowerIsVeteran?: boolean;
    coborrowerIncome?: number;
    coborrowerCreditScoreMedian?: number;
    revolvingDebt?: number;
    revolvingDebtMonthlyPayment?: number;
    propertyStreet?: string;
    propertyCity?: string;
    propertyCounty?: string;
    propertyState?: string;
    propertyZip?: string;
    stateCode?: string;
    countyCode?: string;
    propertyTypeDescription?: string;
    numUnits?: number;
    proposedHODPayment?: number;
    proposedHazPayment?: number;
    occupancyTypeDescription?: string;
    purchasePrice?: number;
    appraisedValue?: number;
    loanPurposeDescription?: string;
    mortgageTypeDescription?: string;
    lienPosition?: number;
    loanProduct?: string;
    loanProgramCode?: string;
    loanProgramName?: string;
    amortizationTypeDescription?: string;
    refinanceCashOutAmount?: number;
    baseLoan?: number;
    totalLoanAmount?: number;
    interestRate?: number;
    loanTerm?: number;
    proposedMIPayment?: number;
    piMonthlyPayment?: number;
    pitiMonthlyPayment?: number;
    firstRatio?: number;
    secondRatio?: number;
    ltv?: number;
    cltv?: number;
    loanStatusDesc?: string;
    dateCreated?: Date;
    applicationDate?: Date;
    creditFirstIssuedDate?: Date;
    fundingDate?: Date;
    userID?: number;
    userName?: string;
    organizationID?: number;
  }

  export interface PricingDataFields {
    activeLOChannel?: string;
    principalBalance?: number;
    interestRate?: number;
    piMonthlyPayment?: number;
    totalMonthlyPayment?: number;
    calculatedPaymentsLeft?: number;
    loanDaysOld?: number;
    remainingInterest?: number;
    miMonthlyPayment?: number;
    miRemovalDate?: Date;
    tiMonthlyPayment?: number;
    combinedPrincipalBalance?: number;
    combinedPIPayment?: number;
    combinedTotalMonthlyPayment?: number;
    combinedRemainingInterest?: number;
    propertyValue?: number;
    propertyValueDate?: Date;
    propertyValueSource?: string;
    currentLTV?: number;
    fico?: number;
    ficoDate?: Date;
    ficoSource?: string;
    revolvingDebt?: number;
    revolvingDebtMonthlyPayment?: number;
    revolvingDebtDate?: Date;
    revolvingDebtSource?: string;
    propertyState?: string;
    stateCode?: string;
    propertyCounty?: string;
    countyCode?: string;
    propertyTypeDescription?: string;
    numUnits?: number;
    occupancyTypeDescription?: string;
    loanProduct?: string;
    loanProgramName?: string;
    loanTerm?: number;
    mortgageTypeDescription?: string;
    amortizationTypeDescription?: string;
    activeLONMLS?: string;
    activeLOName?: string;
    activeLOUserId?: number;
    activeLOUserName?: string;
    organizationID?: number;
    isJV?: boolean;
  }

  export interface PricingResultsWrapper {
    loanLimit?: number;
    nationalLoanLimit?: number;
    branchName?: string;
    byteOrganizationID?: number;
    maxCashOutAmount?: number;
    products?: ProductData[];
    defaultTermRefiProduct?: string;
    defaultRateReductionRefiProduct?: string;
    defaultMIRemovalRefiProduct?: string;
    defaultCashOutRefiProduct?: string;
    defaultDebtConsolidationProduct?: string;
  }

  export interface ProductData {
    product?: string;
    productTable?: string;
    productType?: string;
    productMatchesCurrent?: boolean;
    mortgageType?: string;
    conformingCalculated?: string;
    productTerm?: number;
    totalNumberPayments?: number;
    branchMargin?: number;
    costToProduce?: number;
    cashOutOptions?: CashOutOption[];
    miRemovalRefiProdRank?: number;
    termRefiProdRank?: number;
    rateReductionRefiProdRank?: number;
    cashOutRefiProdRank?: number;
    debtConsolidationProdRank?: number;
  }

  export interface CashOutOption {
    downPaymentPercentage?: number;
    pricingLTV?: number;
    loanAmount?: number;
    cashOutAmount?: number;
    cashOutType?: CashOutType;
    cashOutInd?: boolean;
    rateTable?: RateTableEntry[];
  }

  export enum CashOutType {
    Debt = 'Debt',
    Max = 'Max',
    Mid = 'Mid',
    None = 'None',
  }

  export enum HelocType {
    Max = 'Max',
    Mid = 'Mid',
  }

  export interface RateTableEntry {
    ctpLastModified?: Date;
    bmLastModified?: Date;
    totalOtherAdjustments?: number;
    otherAdjLastModified?: Date;
    ficoAdjustment?: number;
    ficoLastModified?: Date;
    lockPriceUpdated?: Date;
    rate?: number;
    lockPrice30?: number;
    finalPrice?: number;
    finalPrice100?: number;
    parRate?: number;
    belowParRate?: number;
    rateCost?: number;
    estClosingCost?: number;
    totalEstClosingCost?: number;
    netCashOut?: number;
    rateDelta?: number;
    newMonthlyPIPayment?: number;
    monthlyPIPaymentDelta?: number;
    newMonthlyMIPayment?: number;
    monthlyMIPaymentDelta?: number;
    monthsRemainingMIPayment?: number;
    totalMISavings?: number;
    newMonthlyTotalPayment?: number;
    newMonthlyTotalPaymentWithHOA?: number;
    currentTotalPaymentWithHOA?: number;
    monthlyTotalPaymentDelta?: number;
    totalInterest?: number;
    totalInterestDelta?: number;
    lifeNetBenefit?: number;
    numberPaymentsDelta?: number;
    rdMonthlyPIPayment?: number;
    rdLeftoverMonthlyPayment?: number;
    rdNewMonthlyPIPayment?: number;
    rdMonthlyPIPaymentDelta?: number;
    cashOutForDebt?: number;
    cashOutLeftover?: number;
    year1Savings?: number;
    year5Savings?: number;
    monthsToBreakeven?: number;
    termRefiFlag?: boolean;
    termRefiScore?: number;
    rateReductionRefiFlag?: boolean;
    rateReductionRefiScore?: number;
    miRemovalRefiFlag?: boolean;
    miRemovalRefiScore?: number;
    miRemovalRefiRateRank?: number;
    termRefiRateRank?: number;
    rateReductionRefiRateRank?: number;
    cashOutRefiRateRank?: number;
    debtConsolidationRateRank?: number;
    cashOutRefiFlag?: boolean;
    cashOutRefiScore?: number;
    debtConsolidationFlag?: boolean;
    debtConsolidationScore?: number;
  }

  export interface ServicingDataFields {
    phone1?: string;
    phone2?: string;
    email1?: string;
    email2?: string;
    borrowerName?: string;
    borrowerLastName?: string;
    borrowerFirstName?: string;
    borrowerSSN?: string;
    coborrowerName?: string;
    coborrowerLastName?: string;
    coborrowerFirstName?: string;
    coborrowerSSN?: string;
    billingStreet?: string;
    billingCity?: string;
    billingState?: string;
    billingZip?: string;
    propertyStreetNumber?: string;
    propertyStreetName?: string;
    propertyCity?: string;
    propertyState?: string;
    propertyZip?: string;
    propertyStateCode?: string;
    propertyCountyCode?: string;
    propertyType?: string;
    occupancyType?: string;
    servicingLoanProduct?: string;
    mortgageType?: string;
    amortizationType?: string;
    loanPurpose?: string;
    lienPosition?: number;
    originalAppraisedValue?: number;
    originalLoanAmount?: number;
    principalBalance?: number;
    interestRate?: number;
    loanTerm?: number;
    loanClosingDate?: Date;
    firstDueDate?: Date;
    loanMaturityDate?: Date;
    calculatedPaymentsLeft?: number;
    remainingInterest?: number;
    miMonthlyPayment?: number;
    miRemovalDate?: Date;
    tiMonthlyPayment?: number;
    piMonthlyPayment?: number;
    totalMonthlyPayment?: number;
    lastFullPaymentDate?: Date;
    escrowBalance?: number;
    payHistory?: string;
    delinquencyCode?: string;
    acquisitionDate?: Date;
    payoffRequestDate?: Date;
    payoffValidThruDate?: Date;
    servicer?: string;
    servicingStatus?: string;
    reportDate?: Date;
    propertyValue?: number;
    propertyValueDate?: Date;
    fico?: number;
    ficoDate?: Date;
    equity?: number;
    equity80LTV?: number;
    loanOfficerNMLS?: string;
    lastDataEnrichmentDate?: Date;
  }

  export interface SendServicingOfferRequest {
    emailTemplateType?: EmailTemplateType;
    email?: string;
    borrowerFirstName?: string;
    propertyStreet?: string;
    propertyValue?: number;
    ficoDate?: Date;
    revolvingDebt?: number;
    revolvingDebtMonthlyPayment?: number;
    debtConsolidation?: DebtConsolidationData;
    testRecord?: boolean;

    // Renamed: Added "Offer" prefix, due to naming collision.
    maxCashOutOption?: OfferCashOutOption;
    midCashOutOption?: OfferCashOutOption;
    emailTemplateContent?: EmailTemplateContent;
  }

  export interface DebtConsolidationData {
    rdMonthlyPIPaymentDelta?: number;
    rdMonthlyPIPayment?: number;
    rdNewMonthlyPIPayment?: number;
    loanAmount?: number;
    totalEstClosingCost?: number;
    pricingLTV?: number;
    rate?: number;
    newRate?: number;
    newMonthlyPIPayment?: number;
    totalNumberPayments?: number;
    term?: number;
  }

  // Renamed: Added "Offer" prefix, due to naming collision.
  export interface OfferCashOutOption {
    cashOutAmount?: number;
    loanAmount?: number;
    totalEstClosingCost?: number;
    pricingLTV?: number;
    rate?: number;
    newRate?: number;
    newMonthlyPIPayment?: number;
    totalNumberPayments?: number;
    term?: number;
    lifeNetBenefit?: number;
    monthlyPIPaymentDelta?: number;
    monthlyPIPayment?: number;
  }

  export interface EmailTemplateContent {
    loanAmount?: number;
    totalEstClosingCost?: number;
    pricingLTV?: number;
    newRate?: number;
    newMonthlyPIPayment?: number;
    totalNumberPayments?: number;
    term?: number;
    rate?: number;
    monthlyPIPaymentDelta?: number;
    monthlyPIPayment?: number;
    lifeNetBenefit?: number;
    maxAmount?: number;
    midAmount?: number;
  }

  export interface MarketingAutomation {
    guid?: string;
    description?: string;
    videoUrl?: string;
    opportunityTypes?: MarketingAutomationOpportunityType[];
  }

  export interface MarketingAutomationOpportunityType {
    guid?: string;
    opportunityType?: string;
    subscribed?: boolean;
    discountPointsForOffer?: number;
    emailPreviewUrl?: string;
    eligibilityParameters?: EligibilityParameter[];
  }

  export interface ImportPastFundedLoansConfigRequest {
    guid?: string;
    isAllowed?: boolean;
  }

  export interface ImportPastFundedLoansConfigResponse {
    guid?: string;
    description?: string;
    videoUrl?: string;
    isAllowed?: boolean;
  }

  export interface VideosResponse {
    guid?: string;
    externalVideoID?: string;
    name?: string;
  }

  export interface VideoInfoResponse {
    playbackUrl?: string;
    thumbnailUrl?: string;
    // ui
    guid?: string;
    externalVideoID?: string;
    name?: string;
  }
  export enum VideoName {
    IMPORT_PAST_LOANS_PAGE = 'ImportPastLoansPage',
    MARKETING_AUTOMATIONS_PAGE = 'MarketingAutomationsPage',
  }
  export interface PastFundedLoans {
    numberOfAvailableLoansToImport?: number;
    optedIn?: boolean;
  }

  export interface OptInData {
    nmls?: string;
    programName?: string;
    programId?: number;
    subscribed?: number;
    startDate?: Date;
    endDate?: Date;
  }

  export interface EligibilityParameter {
    label?: string;
    value?: string;
  }

  export interface MarketingAutomationConfigRequest {
    guid?: string;
    opportunityType?: string;
    subscribed?: boolean;
    discountPointsForOffer?: number;
  }

  export enum EligibilityParameterType {
    LTV = 'LTV',
    DTI = 'DTI',
    FICO = 'FICO',
    LoanBalance = 'Loan Balance',
    LoanStage = 'Loan Stage',
    PropertyType = 'Property Type',
  }

  export enum OpportunityType {
    CashOutRefi = 'CashOutRefi',
    DebtConsolidation = 'DebtConsolidation',
    MIRemoval = 'MIRemoval',
    RateRefi = 'RateRefi',
    HELOC = 'HELOC',
  }

  export interface Item {
    id: number;
    value: string;
  }

  export interface LeadConversionResponse {
    loanFileDataId?: number;
    loanFileName?: string;
    warnings?: LeadConversionWarning[];
  }

  export interface LeadConversionWarning {
    code?: string;
    message?: string;
  }

  export enum HeatMapColumnNamesEnum {
    EstCashout = 'maxCashOutAmount',
    RevolvingDebt = 'revolvingDebt',
  }

  export type MinMaxColumValuesMap = Record<HeatMapColumnNamesEnum, { min: number; max: number }>;

  export enum LOSValues {
    DataTrac = 'DataTrac',
    BytePro = 'BytePro',
  }

  // Server-side Pipeline Models
  export enum PipelineSearchFilterOperator {
    InList = 0,
    Equals = 1,
    NotEquals = 2,
    LessThan = 3,
    LessThanOrEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    Between = 7,
    Blank = 8,
    NotBlank = 9,
    StartsWith = 10,
    EndsWith = 11,
    Contains = 12,
    NotContains = 13,
    DateIs = 14,
    DateIsNot = 15,
    DateBefore = 16,
    DateOnOrBefore = 17,
    DateAfter = 18,
    DateOnOrAfter = 19,
  }

  export interface PipelineSearchSort {
    colId: string;
    sort: string;
  }

  export interface PipelineSearchColumn {
    ColId: string;
    Field: string;
    HeaderName: string;
    Type: string;
  }

  export interface PipelineSearchCriteria {
    filters: FilterCollection;
    globalSearchQuery?: string;
    layout?: string;
    pageNumber?: number;
    pageSize?: number;
    sorts: PipelineSearchSort[];
    columns?: PipelineSearchColumn[];
    pipelineType?: IntegrationPipelineType;
  }

  export interface PipelineSearchResponse {
    loans: PipelineLoanFile[];
    total: number;
  }

  export type FilterCollection = { [key: string]: Filter };
  export type Filter = {
    operator: 'AND' | 'OR';
    filterType: string;
    condition1: FilterType;
    condition2: FilterType;
    values?: string[] | number[] | boolean[];
    filter?: string | number;
    type?: ComparisonType;
  };
  export type FilterType = {
    filterType: string;
    values?: string[];
    filter?: string | number;
    type?: ComparisonType;
    operator?: 'AND' | 'OR';
  };
  export type ComparisonType =
    | 'equals'
    | 'notEqual'
    | 'lessThan'
    | 'lessThanOrEqual'
    | 'greaterThan'
    | 'greaterThanOrEqual'
    | 'blank'
    | 'notBlank'
    | 'contains'
    | 'notContains'
    | 'startsWith'
    | 'endsWith';

  export enum ViewCategories {
    Global = 'Global',
    SalesOpportunities = 'Sales Opportunities',
    Custom = 'Custom',
  }

  export enum IntegrationPipelineType {
    Byte = 2,
  }

  export class DefaultPartnersErrorMessage {
    static createEmptyModel(): ToastMessageOptions {
      const model: ToastMessageOptions = {
        severity: 'error',
        summary: 'Action failed',
        detail: 'Please refresh and try again, or contact support.',
      };
      return model;
    }
  }

  export interface Organization {
    orgId: string;
    code: string;
    name: string;
    displayName: string;
  }
}
